import Vue from 'vue'
import store from "./store";
import router from './router'
import {hc, html_filter, tc_left} from "./func/util";
import './component'

// window.get_host = 'http://localhost:8080/'
Vue.config.productionTip = false
Vue.mixin({
    data() {
        return {
            get_host: window.get_host,
        }
    },
    methods: {
        hc,
        html_filter,
        tc_left,
        getList(list_field, to, from) {

            const self = this;
            console.log(to.params)
            console.log(self.$store.state)
            if (parseInt(to.params[list_field]) <= self.$store.state[list_field].page) {
                return;
            }
            const check = parseInt(to.params[list_field]) - parseInt(from.params[list_field]);
            if (check > 0) {
                console.log('check ok')
                self.$store.dispatch('getList', {
                    list_field: list_field,
                    start: parseInt(from.params[list_field]) + 1,
                    range: parseInt(to.params[list_field]) - parseInt(from.params[list_field])
                })
            }
        }
    }
});
const vm = new Vue({
    el: '#app',
    store,
    router,
    created() {

        this.$nextTick(function () {
            const from = {params:{latest_list: 1, hot_list: 1}}
            const to = vm.$route
            vm.getList('latest_list', to, from);
            vm.getList('hot_list', to, from);
        })
    }
})


router.beforeEach((to, from, next) => {
    // ...

    vm.getList('latest_list', to, from);
    vm.getList('hot_list', to, from);
    next();
})
